import type { LoadingState } from '@ipfabric/ui-components/utils/loading/withLoadingIndicator';
import type { TablesUrlGetResponseBody } from '@ipfabric/utils';
import type { ApiTableModel } from 'components/ApiTable/model/ApiTableModel';
import { applySharedView } from 'components/ApiTable/model/commands/applySharedView';
import { TABLE_SHARED_VIEW_QUERY_PARAMETER } from 'components/ApiTable/model/commands/shareTableView';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useApi } from 'utils/request/useApi';

interface ApiTableSharedViewHook {
  loading: boolean;
}

export const useTableSharedView = (
  apiTableModel: ApiTableModel,
): ApiTableSharedViewHook => {
  const [searchParams] = useSearchParams();
  const sharedViewId = searchParams.get(TABLE_SHARED_VIEW_QUERY_PARAMETER);
  // immediately start loading to prevent rendering the table and fetching data before view is fetched
  const [loading, setLoading] = useState<LoadingState>(
    sharedViewId === null ? 'INITIAL' : 'LOADING',
  );
  const api = useApi();

  useEffect(() => {
    (async () => {
      if (sharedViewId === null) {
        return;
      }
      try {
        apiTableModel.dispatch(applySharedView, {
          view: await api.request<TablesUrlGetResponseBody>({
            url: `/tables/url/${sharedViewId}`,
          }),
        });
      } finally {
        setLoading('LOADED');
      }
    })();
  }, [sharedViewId, apiTableModel.dispatch]);

  return {
    loading: loading === 'LOADING',
  };
};
